import { auth } from "../firebase";

// The atlas HTML is served by the brainAtlas function, which verifies the
// caller's Firebase id token and that they are a Tribed admin. A browser cannot
// attach an Authorization header to a top-level navigation, so the /brain
// screen fetches the document here and renders it into a sandboxed iframe.
// The function is called directly (not through a Hosting rewrite) so the header
// is guaranteed to reach it; it allows the NobleAdmin origins via CORS.
const BRAIN_ATLAS_URL =
  "https://us-central1-noblepath-ac2df.cloudfunctions.net/brainAtlas";

export const fetchBrainAtlas = async (): Promise<string> => {
  const user = auth.currentUser;
  if (!user) throw new Error("Sign in to view the Brain atlas.");

  const response = await fetch(BRAIN_ATLAS_URL, {
    headers: { Authorization: `Bearer ${await user.getIdToken()}` },
  });

  if (response.status === 401) {
    throw new Error("Your session expired. Sign in again to view the atlas.");
  }
  if (response.status === 403) {
    throw new Error("The Brain atlas is restricted to the Tribed admin account.");
  }
  if (response.status === 404) {
    throw new Error(
      "No atlas has been uploaded yet. It appears after the next scheduled Second Brain graph build."
    );
  }
  if (!response.ok) {
    throw new Error(`Could not load the Brain atlas (${response.status}).`);
  }
  return response.text();
};
